<template>
  <b-tab :title="$store.state.localization.data.mainPage.fuelTankCard.fuelLevelTabLabel">
    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.sensorIdLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        readonly
        v-model="fuelTankCard.sensorId"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.identifierLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        :readonly="
          $store.state.authentication.roles.indexOf(
            ADMIN_ROLE
          ) == -1
        "
        v-model="fuelTankCard.identifier"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.networkAddressLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        :readonly="
          $store.state.authentication.roles.indexOf(
            ADMIN_ROLE
          ) == -1
        "
        v-model="fuelTankCard.networkAddress"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.fuelLevelCorrectionLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="-9999999999"
        max="9999999999"
        :readonly="
          $store.state.authentication.roles.indexOf(
            ADMIN_ROLE
          ) == -1
        "
        v-model="fuelTankCard.fuelLevelCorrection"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.sensorVerificationDateLabel"
      label-for="input-horizontal"
    >
      <b-form-datepicker
        v-model="sensorVerificationDate"
        placeholder="Выберите дату"
        locale="ru"
        autocomplete="off"
        size="sm"
        :date-format-options="{
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }"
      ></b-form-datepicker>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.sensorVerificationNumberLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        v-model="fuelTankCard.sensorVerificationNumber"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.sensorVerificationFileNameLabel"
      label-for="input-horizontal"
    >
      <b-link href="#" @click.prevent="downloadVerificationFile()">{{
        fuelTankCard.sensorVerificationFileName
      }}</b-link>

      <b-form-file
        v-model="sensorVerificationFile"
        placeholder="Загрузить файл"
        drop-placeholder="Drop file here..."
        plain
        accept=".jpg, .png, .gif, .pdf, .doc, .docx"
      ></b-form-file>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.sensorCalibrationDateLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        readonly
        v-model="sensorCalibrationDate"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.calibrationFileLabel"
      label-for="input-horizontal"
    >
      <b-link href="#" @click.prevent="downloadCalibrationFile()">{{
        fuelTankCard.calibrationFile
      }}</b-link>
    </b-form-group>
  </b-tab>
</template>

<script>
import { fuelTankService, utilsService, roleService } from "../../../services";

export default {
  name: "FuelLevelSensorTab",
  props: {
    fuelTankCard: Object,
  },
  data() {
    return {
      sensorVerificationDate: null,
      sensorCalibrationDate: null,
      sensorVerificationFile: null,
      ADMIN_ROLE: roleService.ADMIN_ROLE
    };
  },
  created() {
    if (this.fuelTankCard.sensorVerificationDate) {
      this.sensorVerificationDate = utilsService.convertUnixTimeToDate(
        this.fuelTankCard.sensorVerificationDate
      );
    }

    const calibrationDate = utilsService.convertUnixTimeToDate(
      this.fuelTankCard.calibrationDate
    );

    if (calibrationDate) {
      this.sensorCalibrationDate = utilsService.formatDateTime(
        calibrationDate,
        utilsService.DATE_TIME_FORMAT
      );
    }
  },
  methods: {
    async downloadCalibrationFile() {
      await fuelTankService.downloadFuelTankCalibration(
        this.fuelTankCard.calibrationFile,
        this.fuelTankCard.vehicleId,
        this.fuelTankCard.sensorId
      );
    },
    async downloadVerificationFile() {
      await fuelTankService.downloadSensorVerificationFile(
        this.fuelTankCard.sensorVerificationFileName,
        this.fuelTankCard.vehicleId,
        this.fuelTankCard.sensorId
      );
    },
    getSensorVerificationDate() {
      if (this.sensorVerificationDate) {
        return Date.parse(this.sensorVerificationDate);
      }
      return null;
    },
    getSensorVerificationNumber() {
      if (this.fuelTankCard.sensorVerificationNumber) {
        return this.fuelTankCard.sensorVerificationNumber;
      }
      return null;
    },
    getSensorVerificationFileName() {
      if (this.sensorVerificationFile) {
        return this.sensorVerificationFile.name;
      }
      return null;
    },
    async getSensorVerificationFile() {
      if (this.sensorVerificationFile) {
        const buffer = await this.sensorVerificationFile.arrayBuffer();
        return utilsService.arrayBufferToBase64(buffer);
      }
      return null;
    },
  },
};
</script>
